import React from 'react';
import {ReactComponent as StudentTypeSvg} from "../assets/svg/student-type.svg";
import {ReactComponent as GuardianTypeSvg} from "../assets/svg/guardian-type.svg";
import {ReactComponent as ClassTypeSvg} from "../assets/svg/class-type.svg";
import {ReactComponent as TeacherTypeSvg} from "../assets/svg/teacher-type.svg";
import {ReactComponent as LogoutTypeSvg} from "../assets/svg/log-out.svg";
import {ReactComponent as SubjectTypeSvg} from "../assets/svg/subject-type.svg";

export type MenuOptionValue =
    | "dashboard"
    | "classes"
    | "students"
    | "teachers"
    | "guardians"
    | "demo-classroom"
    | "settings"
    | "subjects"
    | "logout";

export class MenuOption {
    static DASHBOARD = "dashboard" as const;
    static CLASSES = "classes" as const;
    static STUDENTS = "students" as const;
    static TEACHERS = "teachers" as const;
    static GUARDIANS = "guardians" as const;
    static DEMO_CLASSROOM = "demo-classroom" as const;
    static SETTINGS = "settings" as const;
    static SUBJECTS = "subjects" as const;
    static LOGOUT = "logout" as const;

    type: MenuOptionValue;

    constructor(type: MenuOptionValue) {
        this.type = type;
    }

    getLogo(): React.ReactElement {
        switch (this.type) {
            case MenuOption.STUDENTS:
                return <StudentTypeSvg/>;
            case MenuOption.GUARDIANS:
                return <GuardianTypeSvg/>;
            case MenuOption.TEACHERS:
                return <TeacherTypeSvg/>;
            case MenuOption.CLASSES:
                return <ClassTypeSvg/>;
            case MenuOption.SUBJECTS:
                return <SubjectTypeSvg/>;
            case MenuOption.LOGOUT:
                return <LogoutTypeSvg/>;
            default:
                return <></>;
        }
    }

    getSingularWord(): string {
        switch (this.type) {
            case MenuOption.STUDENTS:
                return 'Student';
            case MenuOption.GUARDIANS:
                return 'Guardian';
            case MenuOption.TEACHERS:
                return 'Teacher';
            case MenuOption.CLASSES:
                return 'Class';
            case MenuOption.SETTINGS:
                return 'Setting';
            case MenuOption.SUBJECTS:
                return 'Subject';
            case MenuOption.LOGOUT:
                return 'Logout';
            default:
                return '';
        }
    }
}

export function getAllMenuOptions(): string[] {
    const options: string[] = [];

    for (const key in MenuOption) {
        //remove subject option -- not to be displayed on the menu
        if (Object.hasOwnProperty.call(MenuOption, key) && key !== MenuOption.SUBJECTS) {
            options.push((MenuOption as unknown as Record<string, string>)[key]);
        }
    }

    return options;
}

export function getCurrentUrlMenuOption(): string {
    const currentUrl = window.location.href;

    for (const menuOption of getAllMenuOptions()) {
        if (currentUrl.includes(menuOption)) {
            return menuOption;
        }
    }

    return MenuOption.DASHBOARD;
}
